import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

type IconVariant = 'light' | 'white' | 'colored' | 'dark';

interface Props {
  variant: IconVariant;
}

const bar1Fill: { [Variant in IconVariant]: string } = {
  light: '#B8C7CE',
  white: '#FFF',
  colored: '#DE392C',
  dark: '#323232',
};

const bar2Fill: { [Variant in IconVariant]: string } = {
  light: '#B8C7CE',
  white: '#FFF',
  colored: '#FAA529',
  dark: '#323232',
};

const bar3Fill: { [Variant in IconVariant]: string } = {
  light: '#B8C7CE',
  white: '#FFF',
  colored: '#4F81BD',
  dark: '#323232',
};

const bar4Fill: { [Variant in IconVariant]: string } = {
  light: '#B8C7CE',
  white: '#FFF',
  colored: '#A8CB60',
  dark: '#323232',
};

const BareIntentVerificationIcon: FC<SvgWrapperProps & Props> = ({
  variant,
  ...props
}) => (
  <SvgWrapper height='20' viewBox='0 0 20 20' width='20' {...props}>
    <rect
      x='14'
      y='7'
      fillRule='evenodd'
      clipRule='evenodd'
      fill={bar1Fill[variant]}
      width='3'
      height='11'
    />
    <rect
      x='10'
      y='3'
      fillRule='evenodd'
      clipRule='evenodd'
      fill={bar2Fill[variant]}
      width='3'
      height='15'
    />
    <rect
      x='6'
      y='11'
      fillRule='evenodd'
      clipRule='evenodd'
      fill={bar3Fill[variant]}
      width='3'
      height='7'
    />
    <rect
      x='2'
      y='7'
      fillRule='evenodd'
      clipRule='evenodd'
      fill={bar4Fill[variant]}
      width='3'
      height='11'
    />
  </SvgWrapper>
);
export const IntentVerificationIcon = memo(BareIntentVerificationIcon);
